/*
 Created by qing on 2020/8/3
 Des:
 */

import BaseItem from "../BaseItem";
import {
  DATA_TYPE__STRING,
  FORM_ITEM__OUT_REQUEST,
  FORM_STATUS__FILL
} from "../types";

class OutRequest extends BaseItem {
  constructor() {
    super()

    // 填写内容
    this.value = ''

    this.requestType = 0 // 0 文本输入型(目前只有这种) 1 下拉框类型
    this.triggerType = 1 //1 焦点触发 2 失焦触发 3 按钮触发
    this.buttonName = "" //按钮名称
    this.buttonColor = "#2196F3"
    this.showAlert = 0 //是否显示弹窗 0 否 1 是
    this.alertText = "" // 弹窗文字内容
    this.requestUrl = "" // 请求的url 可以添加控件字段
    this.methodType = 0 // 0 get 1 post
    this.headerList = [
      /*
      {
        "headerKey":"",
        "headerValue":"",
        "valueType":0, // 0 直接输入 1 表单获取
        "appId":"",
        "formId":"",
        "filterInfo":{
          "relation":"and",  //条件之间的关系 and查询 或者 or 查询
          "notJumpEmpty":0, //是否不跳过空值过滤 0 跳过 1 不跳过
          "conditionList":[
            {
              "type":"number", //控件的类型
              "method":"eq", //匹配的方法
              "value":[  //匹配的值
                25
              ],
              "fieldId":"控件的Id" //当时子表单的控件时 需要为"tableFiledId.subFiledId"
            }
          ]
        }//过滤器 结果取第一条
      }
       */
    ]
    this.paramType = 0 // 0 json 1 x-www-form-urlencoded
    this.paramList = [
      /*
      {
        "paramKey":"123123",
        "type":0, // 0 自定义 1 字段
        "paramValue":"13123123123", //自定义的值
        "fieldId":"控件的Id"
      }
       */
    ] //x-www-form-urlencoded 类型
    this.requestBody = ""   // 请求body 可以添加控件字段 json 类型取此参数
    this.resultList = [
      /*
      {
        "resultId":"前端生成Id",
        "resultAlias":"结果别名",
        "findType":0, // 0 jsonPath 目前只支持jsonPath
        "jsonPath":"jsonPathStr"
      }
       */
    ] //结果提取
    this.updateList = [
      /*
      {
        "resultId":"结果提取的Id",
        "fieldId":"控件的Id"
      }
       */
    ]
  }

  get title() {
    return this.fieldTitle || OutRequest._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

OutRequest._title = '智能连接'
OutRequest.type = FORM_ITEM__OUT_REQUEST
OutRequest.use = true
OutRequest.icon = 'iconfont icon-webhook'

// 组件类型
OutRequest.prototype.type = OutRequest.type
// 数据类型
OutRequest.prototype.dataType = DATA_TYPE__STRING

OutRequest.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '等于任意一个',
    method: 'in'
  },
  {
    name: '不等于任意一个',
    method: 'nin'
  },
  {
    name: '包含',
    method: 'like'
  },
  {
    name: '不包含',
    method: 'unlike'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
OutRequest.prototype.getValue = function () {
  return this.value
}
OutRequest.prototype.setValue = function (val) {
  this.value = val || ''
}
OutRequest.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    requestType: this.requestType,
    triggerType: this.triggerType,
    buttonName: this.buttonName,
    buttonColor: this.buttonColor,
    showAlert: this.showAlert,
    alertText: this.alertText,
    requestUrl: this.requestUrl,
    methodType: this.methodType,
    headerList: this.headerList,
    paramType: this.paramType,
    paramList: this.paramList,
    requestBody: this.requestBody,
    resultList: this.resultList,
    updateList: this.updateList
  }
}
OutRequest.prototype.setConf = function (opts) {
  this.setBase(opts)
  this.requestType = opts.requestType
  this.triggerType = opts.triggerType
  this.buttonName = opts.buttonName
  this.buttonColor = opts.buttonColor
  this.showAlert = opts.showAlert
  this.alertText = opts.alertText
  this.requestUrl = opts.requestUrl
  this.methodType = opts.methodType
  this.headerList = opts.headerList
  this.paramType = opts.paramType
  this.paramList = opts.paramList
  this.requestBody = opts.requestBody
  this.resultList = opts.resultList
  this.updateList = opts.updateList
}
OutRequest.prototype.valueToString = function (value) {
  value = value || this.value
  return value
}

// 检查数据合法性 true合法 false不合法
OutRequest.prototype.checkData = function () {
  return true
  // 判断必填
  // return this.checkWriteValue()
}

// 判断必填项
OutRequest.prototype.checkWriteValue = function () {
  if (this.root.status === FORM_STATUS__FILL && this.required && !this.value.length) {
    return false
  } else {
    return true
  }
}

OutRequest.prototype.colorOpts = [
  '#2196F3',
  '#E91E63',
  '#FF9800',
  '#4CAF50',
  '#00BCD4',
  '#3F51B5',
  '#455A64',
  '#63B2EE',
  '#76DA91',
  '#F8CB7F',
  '#7CD6CF',
  '#9192AB',
  '#7898E1',
  '#EFA666',
  '#9987CE'
]


export default OutRequest